// Issues carry their body as a ProseMirror document in a JSONObject scalar, which cannot
// be written as an inline GraphQL object literal — hence the $input variable. That
// interpolation is what the old commentMutations.create failed on ("Cannot convert object
// to primitive value"), and it also keeps quotes and newlines in user text from breaking
// the query. The selection matches projectIssuesQuery so a created issue can be
// pushed straight into the comment list.
const issueFields = `id,
        createdAt,
        updatedAt,
        status,
        priority,
        dueDate,
        title,
        labels {
          id,
          name,
          hexColor
        },
        author {
          user {
            id,
            name
          }
        },
        description {
          doc,
          attachments {
            id,
            fileName
          }
        },
        replies {
          totalCount,
        },
        viewerState,
        permissions {
          canEditStatus {
            authorized
          },
          canEditPriority {
            authorized
          },
          canEditDueDate {
            authorized
          }
        }`

export const createIssueMutation = () => `mutation ($input: CreateIssueInput!) {
  projectMutations {
    issues {
      createIssue(input: $input) {
        ${issueFields}
      }
    }
  }
}`

export const createIssueReplyMutation = () => `mutation ($input: CreateIssueReplyInput!) {
  projectMutations {
    issues {
      createReply(input: $input) {
        id,
        createdAt,
        author {
          user {
            id,
            name
          }
        },
        description {
          doc,
          attachments {
            id,
            fileName
          }
        }
      }
    }
  }
}`

// Comment threads are Issues server-side: their status (open / readyForReview / resolved),
// priority (none / low / medium / high) and dueDate are updated through
// projectMutations.issues.updateIssue. status and priority are enums, interpolated
// unquoted; dueDate is an ISO 8601 string that must be quoted, or an explicit null
// to clear the due date — so it is included whenever provided, even when null.
export const updateIssueFields = (projectId, issueId, {status, priority, dueDate}) => {
  const fields = [
    `projectId: "${projectId}"`,
    `issueId: "${issueId}"`
  ];
  if (status) {
    fields.push(`status: ${status}`);
  }
  if (priority) {
    fields.push(`priority: ${priority}`);
  }
  if (dueDate !== undefined) {
    fields.push(`dueDate: ${dueDate === null ? 'null' : `"${dueDate}"`}`);
  }
  return `mutation {
  projectMutations {
    issues {
      updateIssue(input: {
        ${fields.join(',\n        ')}
      }) {
        id,
        status,
        priority,
        dueDate
      }
    }
  }
}`
}